import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface InfoDialogData {
  title: string;
  content: string;
  icon: string;
}

@Component({
  selector: 'app-info-dialog',
  template: `
    <div class="info-dialog-container">
      <div class="dialog-header">
        <h2 class="dialog-title">
          <i class="material-icons dialog-icon">{{ data.icon }}</i>
          {{ data.title }}
        </h2>
      </div>
      
      <div class="dialog-body">
        <div class="dialog-content">
          {{ data.content }}
        </div>
      </div>
      
      <div class="dialog-footer">
        <button type="button" class="btn btn-primary" (click)="onAccept()">
          <i class="material-icons">check</i>
          Entendido
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent {
  
  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData
  ) {}

  onAccept(): void {
    this.dialogRef.close();
  }
}